<template>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div class="breadcrumb-title pe-3">Header Special Section</div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><router-link to="/home"><i class="bx bx-home-alt"></i></router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Header Special Section CMS</li>
                        </ol>
                    </nav>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">Header Special Section CMS</h5>
                    <hr />
                    <div class="form-body mt-4">
                        <div class="row">
                            <div class="col-lg-8">
                                <div class="border border-3 p-4 rounded">
                                    <div class="mb-3">
                                        <label class="form-label">Cateogory Title:</label>
                                        <input type="text" v-model="cmsData.categoryTitle" class="form-control" placeholder="Enter category title" />
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label">Deals Title:</label>
                                        <input type="text" v-model="cmsData.title" class="form-control" placeholder="Enter deals title" />
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label">Card Title:</label>
                                        <input type="text" v-model="cmsData.cardTitle" class="form-control" placeholder="Enter card title" />
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label">Card SubTitle:</label>
                                        <input type="text" v-model="cmsData.cardSubtitle" class="form-control" placeholder="Enter card subtitle" />
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label">Card Details:</label>
                                        <input type="text" v-model="cmsData.cardDetails" class="form-control" placeholder="Enter card details" />
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label">Button Text:</label>
                                        <input type="text" v-model="cmsData.buttonText" class="form-control" placeholder="Enter button text" />
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label">Button Link:</label>
                                        <input type="text" v-model="cmsData.buttonLink" class="form-control" placeholder="Enter button link" />
                                    </div>
                                    <div class="d-grid">
                                        <button @:click="update()" type="button" class="btn btn-primary">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="../js/header-special-section-cms.js"></script>